
import Vue from "vue";
import ReminderAutoList from "@/components/sales/ReminderAutoList.vue";
import {ReminderService} from "@/services/reminder-service";
import { Sale } from "@/models/base";
import { Reminder } from "@/models/reminder";
import { ReminderConfig } from "@/models/dossier-configs/reminder-config";
import { differenceInMonths } from "date-fns";
import { DossierConfigService } from "@/services/dossier-config-service";

export default Vue.extend({
	data() {
		return {
			sales: [] as Sale[],
			reminders: [] as Reminder[],
			selectedReminders: [] as Reminder[],
			config: DossierConfigService.getReminderConfig(),
		};
	},
	methods: {
		makeReminders(sales: Sale[]) {
			this.reminders = sales.map(s => {

				let reminder = new Reminder();
				reminder.Cost = 0;
				reminder.Sale = s;
				reminder.SaleID = s.ID;

				if (this.config && this.config.AutoCalculateCosts) {
					let cost = (this.config["HCost" + (s.Reminder < 4 ? s.Reminder + 1 : 4) as keyof ReminderConfig] as number);
					reminder.Cost = cost;
					let costPerc = (this.config["HPerc" + (s.Reminder < 4 ? s.Reminder + 1 : 4) as keyof ReminderConfig] as number);
					if (costPerc) {
						reminder.Cost = (reminder.Sale.TotalOpen / 100) * costPerc;
					}
					let intrests = this.config["Intrests"] as number;
					if (intrests) {
						let diff = differenceInMonths(new Date(),reminder.Sale.ExpirationDate);
						diff = diff < 1 ? 1 : diff;
						reminder.Interest = ((reminder.Sale.TotalOpen / 100) * intrests) * diff;
					}
				}

				return reminder;
			});
			this.selectedReminders.push(...this.reminders);
		},
		close(){
			this.$emit("close");
		}
	},
	async created(){
		this.sales = await ReminderService.listAutoReminders();
		this.makeReminders(this.sales);
	},
	components: {
		ReminderAutoList
	}
});
